<template>
  <div class="billing-summary-container">
    <div class="billing-summary">
      <BillingCycleLabel></BillingCycleLabel>
      <BillingCycleLabel
        v-for="(month, index) in billingMonths"
        :key="month.name"
        :style="`grid-column-start: ${index + 2}`"
        :name="month.name"
      >
      </BillingCycleLabel>

      <BillingLineItemLabel label="Starting Balance" emphasized>
      </BillingLineItemLabel>
      <BillingLineItemValue v-for="month in billingMonths" emphasized>
        {{ formatCurrency(month.starting_balance) }}
      </BillingLineItemValue>

      <BillingLineItemLabel
        label="Simple Questionnaires"
        subtext="2021 Tax Year"
      >
      </BillingLineItemLabel>
      <BillingLineItemValue v-for="month in billingMonths">
        <BillingUsageSummary
          :usage="month.simple_2021_usage"
          :price="month.simple_price"
        ></BillingUsageSummary>
      </BillingLineItemValue>

      <BillingLineItemLabel
        label="Simple Questionnaires"
        subtext="2022 Tax Year"
      >
      </BillingLineItemLabel>
      <BillingLineItemValue v-for="month in billingMonths">
        <BillingUsageSummary
          :usage="month.simple_2022_usage"
          :price="month.simple_price"
        ></BillingUsageSummary>
      </BillingLineItemValue>

      <BillingLineItemLabel
        label="Complex Questionnaires"
        subtext="2021 Tax Year"
      >
      </BillingLineItemLabel>
      <BillingLineItemValue v-for="month in billingMonths">
        <BillingUsageSummary
          :usage="month.complex_2021_usage"
          :price="month.complex_price"
        ></BillingUsageSummary>
      </BillingLineItemValue>

      <BillingLineItemLabel
        label="Complex Questionnaires"
        subtext="2022 Tax Year"
      >
      </BillingLineItemLabel>
      <BillingLineItemValue v-for="month in billingMonths">
        <BillingUsageSummary
          :usage="month.complex_2022_usage"
          :price="month.complex_price"
        ></BillingUsageSummary>
      </BillingLineItemValue>

      <BillingLineItemLabel
        label="Business Questionnaires"
        subtext="2021 Tax Year"
      >
      </BillingLineItemLabel>
      <BillingLineItemValue v-for="month in billingMonths">
        <BillingUsageSummary
          :usage="month.business_entity_2021_usage"
          :price="month.business_entity_price"
        ></BillingUsageSummary>
      </BillingLineItemValue>

      <BillingLineItemLabel
        label="Business Questionnaires"
        subtext="2022 Tax Year"
      >
      </BillingLineItemLabel>
      <BillingLineItemValue v-for="month in billingMonths">
        <BillingUsageSummary
          :usage="month.business_entity_2022_usage"
          :price="month.business_entity_price"
        ></BillingUsageSummary>
      </BillingLineItemValue>

      <BillingLineItemLabel label="Credits Used" emphasized>
      </BillingLineItemLabel>
      <BillingLineItemValue v-for="month in billingMonths" emphasized>
        {{ formatCurrency(month.credits_used) }}
      </BillingLineItemValue>

      <BillingLineItemLabel label="New Charges" emphasized>
      </BillingLineItemLabel>
      <BillingLineItemValue v-for="month in billingMonths" emphasized>
        {{ formatCurrency(month.amount_charged) }}
      </BillingLineItemValue>

      <BillingLineItemLabel label="Ending Balance" emphasized>
      </BillingLineItemLabel>
      <BillingLineItemValue v-for="month in billingMonths" emphasized>
        {{ formatCurrency(month.ending_balance) }}
      </BillingLineItemValue>
    </div>
  </div>
</template>

<script>
import BillingLineItemLabel from './BillingLineItemLabel.vue';
import BillingLineItemValue from './BillingLineItemValue.vue';
import BillingUsageSummary from './BillingUsageSummary.vue';
import BillingCycleLabel from './BillingCycleLabel.vue';

export default {
  name: 'BillingSummary',
  components: {
    BillingLineItemLabel,
    BillingUsageSummary,
    BillingLineItemValue,
    BillingCycleLabel,
  },
  props: {
    billingMonths: {
      type: Array,
    },
  },
  methods: {
    formatCurrency(value) {
      const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });

      return value ? currencyFormatter.format(value) : '—';
    },
  },
};
</script>

<style scoped>
.billing-summary-container {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.billing-summary {
  display: grid;
  margin-bottom: 4rem;
  grid-template-columns: repeat(4, minmax(125px, max-content));
}
</style>
